<template>
  <OneCol
    :center="true"
    :borderRadius="0"
    :backgroundImage="$store.state.width > 767 ? $store.state.copy.signAsk.image : $store.state.copy.signAsk.imageMob"
    padding="0px"
    maxWidth="100%"
    extraClass="smaller"
  >
    <template v-slot:title>
      <div class="fit_wrap">
        <h1 v-html="$store.state.copy.signAsk.title"></h1>
      </div>
    </template>
    <template v-slot:body>
      <div class="top_section" v-html="$store.state.copy.signAsk.copy">
      </div>
      <div class="bottom_section">
        <div v-html="$store.state.copy.signAsk.question"></div>

        <div class="button_wrap">
          <GenericButton
            @click="gotoSlide('petition'), analytics('signask', 'yes')"
            :text="$store.state.copy.signAsk.yes_btn"
            textColor="white"
            minWidth="220px"
          ></GenericButton>
          <GenericButton
            @click="gotoSlide('shareAsk'), analytics('signask', 'skip'), $store.commit('updateExtraProgress')"
            :text="$store.state.copy.signAsk.no_btn"
            textColor="white"
            minWidth="220px"
            color="#4A4A4A"
            hoverColor="#686868"
          ></GenericButton>
        </div>
      </div>
    </template>
  </OneCol>
</template>

<script>
import OneCol from "../components/template/OneCol";
import GenericButton from "../components/generic/GenericButton";
export default {
  name: "InfoSlide",
  components: {
    OneCol,
    GenericButton
  }
};
</script>
<style lang="scss">
.top_section {
  max-width: 800px;
  padding: 40px;
  margin: 0 auto 20px;
  @media (max-width: 767px) {
    padding: 12px;
    text-align: left;
  }

  p {
    font-size: 22px;
    font-weight: 400;
    line-height: 1.44;
    text-align: left;
    &:last-of-type {
      margin-bottom: 0;
    }

    strong {
      color: #009fe2;
    }
    @media (max-width: 767px) {
      text-align: left;
      font-size: 20px;
      line-height: 24px;
    }
  }
}

.bottom_section {
  background: black;
  padding: 35px 40px;

  p {
    font-size: 24px;
    // font-weight: bold;
    line-height: 1.44;
    text-align: center;
    color: white;

    max-width: 800px;
    padding: 0 40px;
    margin: 0 auto 20px;

    @media (max-width: 767px) {
      margin: 0 auto 10px;
      padding: 0;
      text-align: left;
    }
  }
  @media (max-width: 767px) {
    padding: 12px;
    text-align: left;
    font-size: 16px;
  }
}
</style>